<div class="bc-tab-options">
  @for (tab of data.tabs; track tab) {
    <div class="tab-option" [ngClass]="getClass(tab.id)">
      <mat-icon>{{ tab.icon }}</mat-icon>
      <div class="product-name">
        {{ tab.name | translate }}
      </div>
      <div class="permission-option">
        <mat-select [value]="dropdownOptions[0].id" (selectionChange)="selectChange($event, tab.id, tab.name)">
          @for (opt of dropdownOptions; track opt) {
            <mat-option [value]="opt.id">
              {{ opt.key | translate }}
            </mat-option>
          }
        </mat-select>
      </div>
    </div>
  }
</div>
